/**
 * File-uploadin puhtaat apurit (AB-WP6.10): data-URL:n base64-osan irrotus,
 * koon rajaus ja pudotusviesti. Ei DOMia, ei FileReaderia — nämä testataan
 * suoraan; runtime.ts:n wireFileUpload lukee tiedostot ja kutsuu näitä.
 */
import { resolveMessage } from './messages';

export type PickedFile = { name: string; type: string; size: number; dataBase64: string };

/** Irrota base64-hyötykuorma data-URL:stä ("data:...;base64,AAAA" → "AAAA"); '' jos ei pilkkua. */
export function extractBase64(dataUrl: string): string {
  const i = dataUrl.indexOf(',');
  return i >= 0 ? dataUrl.slice(i + 1) : '';
}

/** true jos tiedosto mahtuu rajaan. maxSizeMb <= 0 (tai virheellinen) = ei rajaa. */
export function isWithinSize(sizeBytes: number, maxSizeMb: number): boolean {
  if (!(maxSizeMb > 0)) return true;
  return sizeBytes <= maxSizeMb * 1024 * 1024;
}

/**
 * Inline-virheteksti liian suurille (pudotetuille) tiedostoille; '' jos ei
 * pudotuksia.
 *
 * <p>Teksti tulee sanastosta (`WP-FU2`). Aiemmin se oli kovakoodattua
 * englantia, joten suomenkielinen App näytti tämän englanniksi täsmälleen
 * kuten `Required` ennen validointiviestityötä — ja koska kyse on
 * virhetilanteesta, sen huomasi vasta se käyttäjä jonka lataus epäonnistui.
 */
export function describeSkipped(names: string[], maxSizeMb: number): string {
  if (names.length === 0) return '';
  return resolveMessage('fileSkipped')
    .replace('{value}', String(maxSizeMb))
    .replace('{names}', names.join(', '));
}
